var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ul',{staticClass:"d-flex flex-column align-items-start justify-content-start"},_vm._l((_vm.navLink),function(link){return _c('irsh-link-item',{key:link.path,staticClass:"hidden",class:link.class,attrs:{"data-category":"mobile-footer-nav","path":link.path,"title":link.title}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }